/** @jsx h */
import { h, VNode } from 'preact';
import { connect } from 'react-redux';
import PaymentContainer from './paymentContainer';
import ActivationContainer from './activationContainer';
import BICContainer from './bicContainer';
import WidgetContainer from './widgetContainer';
import BICRevampContainer from './bicRevampContainer';
import Utils from '../../../utils';
import CheckoutWidgetContainer from './checkoutWidgetConatiner';
import SaleAppContainer from './salesAppContainer';
import { CheckoutProvider } from '../../../storeProviders/checkoutWidgetStore';
import { ErrorModalStoreProvider } from '../../../storeProviders/errorModalStore';
import { SalesAppProvider } from '../../../storeProviders/salesAppStore';
import { useEffect } from 'preact/hooks';
import { initializeTracker } from '../../../tracking';

const SA_CLEVERTAP_TOKEN = process.env.PREACT_APP_SA_CLEVERTAP_TOKEN;
const CLEVERTAP_TOKEN = process.env.PREACT_APP_CLEVERTAP_TOKEN;

type Props = {
  template: string,
  children: VNode,
  showPaymentContainer: Boolean,
  routeDetails: {
    component: string,
    componentName: string,
    path: string,
    template: string,
    theme: string,
  },
};

const Container = ({
  children,
  template,
  showPaymentContainer,
  routeDetails,
}: Props) => {
  useEffect(() => {
    if (template === 'salesApp' || template === 'checkoutWidget') {
      initializeTracker(
        template === 'salesApp' ? SA_CLEVERTAP_TOKEN : CLEVERTAP_TOKEN,
        true,
      );
    }
  }, [template]);

  switch (template) {
    case 'payment':
      return (
        showPaymentContainer && <PaymentContainer>{children}</PaymentContainer>
      );
    case 'activation':
      return <ActivationContainer>{children}</ActivationContainer>;
    case 'home':
    case 'oldHome':
    case 'neutral':
    case 'login':
    case 'account':
      return Utils.isOrganicSite() &&
        (template === 'home' || template === 'account') ? (
        <BICRevampContainer>{children}</BICRevampContainer>
      ) : (
        <BICContainer>{children}</BICContainer>
      );
    case 'widget':
      return <WidgetContainer>{children}</WidgetContainer>;
    case 'checkoutWidget':
      return (
        <ErrorModalStoreProvider template={template}>
          <CheckoutProvider>
            <CheckoutWidgetContainer routeDetails={routeDetails}>
              {children}
            </CheckoutWidgetContainer>
          </CheckoutProvider>
        </ErrorModalStoreProvider>
      );
    case 'salesApp':
      return (
        <ErrorModalStoreProvider>
          <SalesAppProvider routeDetails={routeDetails}>
            <SaleAppContainer>{children}</SaleAppContainer>
          </SalesAppProvider>
        </ErrorModalStoreProvider>
      );
    default:
      return children;
  }
};

const mapStateToProps = ({ config, paymentDetails }) => {
  const { template, routeDetails } = config || {};
  const { showPaymentContainer } = paymentDetails;
  return {
    template,
    showPaymentContainer,
    routeDetails,
  };
};

export default connect(mapStateToProps)(Container);



// WEBPACK FOOTER //
// ./components/partial/container/index.js